import { defaultAxios, constants } from "../data/httpWithAxios";
import qs from "qs";
/**
 * 2018.08.14 shlee
 * 추후에  api에서 return되는 값을 responseMessage로 처리 할것
 */
export default {
  //   export function addBulkOrders(form) {
  //   return request({
  //     url: "/rc/ex/web/order/bulk",
  //     method: "post",
  //     data: form,
  //     headers: { "Content-type": "application/json" },
  //   });
  // }

  addBulkOrders: function(form) {
    return defaultAxios(constants.contentType.application_json)
      .post("/rc/ex/web/order/bulk", form)
      .then(response => {
        return response;
      });
  },

  phoneInfo: {
    vendorPhonebookNo: 0,
    empNo: 0,
    newPhoneNo: null
  },
  employeeList: function(corpNo) {
    return defaultAxios(constants.contentType.application_json)
      .get("/rc/cs/web/corp/employees", {
        params: {
          corpNo: corpNo
        }
      })
      .then(response => {
        return response;
      });
  },
  employeeInfo: function(corpNo, employeeNo) {
    return defaultAxios(constants.contentType.application_json)
      .get("/rc/cs/web/corp/employee/" + employeeNo, {
        params: {
          corpNo: corpNo
        }
      })
      .then(response => {
        return response;
      });
  },
  addEmployee: function(employeeInfo) {
    return defaultAxios(constants.application_json)
      .post("/rc/cs/web/corp/addEmployee", employeeInfo)
      .then(response => {
        return response;
      });
  },
  addEmployees: function(employeeInfos) {
    return defaultAxios(constants.application_json)
      .post("/rc/cs/web/corp/addEmployees", employeeInfos)
      .then(response => {
        return response;
      });
  },
  modifyEmployee: function(employeeInfo) {
    return defaultAxios(constants.application_json)
      .post("/rc/cs/web/corp/updateEmployee", employeeInfo)
      .then(response => {
        return response;
      });
  },

  modifyPhoneNo: function(pid, empNo, newPhoneNo) {
    this.phoneInfo.vendorPhonebookNo = pid;
    this.phoneInfo.empNo = empNo;
    this.phoneInfo.newPhoneNo = newPhoneNo;

    return defaultAxios(constants.application_json)
      .post("/rc/cs/web/corp/updateEmployeePhoneNo", this.phoneInfo)
      .then(response => {
        return response;
      });
  },
  addPhoneNo: function(empNo, phoneNo) {
    this.phoneInfo.empNo = empNo;
    this.phoneInfo.newPhoneNo = phoneNo;

    return defaultAxios(constants.application_json)
      .post("/rc/cs/web/corp/addEmployeePhoneNo", this.phoneInfo)
      .then(response => {
        return response;
      });
  },
  removePhoneNo: function(pid, empNo) {
    this.phoneInfo.vendorPhonebookNo = pid;
    this.phoneInfo.empNo = empNo;

    return defaultAxios(constants.application_json)
      .post("/rc/cs/web/corp/removeEmployeePhoneNo", this.phoneInfo)
      .then(response => {
        return response;
      });
  },
  addDrivers: function(driver) {
    return defaultAxios(constants.application_json)
      .post("/rc/cs/r/d/add", driver)
      .then(response => {
        return response;
      });
  },
  addOrder: function(order) {
    return defaultAxios(constants.application_json, true)
      .post("/rc/cs/web/corp/addOrder", order)
      .then(response => {
        return response;
      });
  },
  addNewOrder: function(order) {
    return defaultAxios(constants.application_json, true)
      .post("/rc/cs/web/corp/new-addOrder", order)
      .then(response => {
        return response;
      });
  },
  searchOrders: function(query) {
    return defaultAxios(constants.contentType.application_json)
      .get("/rc/cs/web/corp/orders", {
        params: query
      })
      .then(response => {
        return response;
      });
  },
  syncOrder: function(order) {
    return defaultAxios(constants.application_json, true)
      .post("/rc/cs/web/corp/sync-order", order)
      .then(response => {
        return response;
      });
  },
  // modifiedHistory: function(query) {
  //     return defaultAxios(constants.contentType.application_json)
  //     .get('/rc/cs/web/corp/history', {
  //         params: query
  //     }).then(response => {
  //         return response;
  //     })
  // },
  modifiedHistory: function(query) {
    return defaultAxios(constants.contentType.application_json, true)
      .post("/rc/cs/web/corp/history", query)
      .then(response => {
        return response;
      });
  },
  modifiedHistoryV2: function(query) {
    return defaultAxios(constants.contentType.application_json, true)
      .post("/rc/cs/web/corp/history/v2", query)
      .then(response => {
        return response;
      });
  },
  selectedVendorsSaveAPI: function(query) {
    return defaultAxios(constants.contentType.application_json, true)
      .post("/rc/cs/web/corp/selected-vendors", query)
      .then(response => {
        // managerNo : number
        // selectedVendors : list
        return response;
      });
  },
  updateModifiedState: function(order) {
    return defaultAxios(constants.contentType.application_json, true)
      .post("/rc/cs/web/corp/modified-state", order)
      .then(response => {
        return response;
      });
  },
  corpList: function(vendorNo) {
    return defaultAxios(constants.contentType.application_json)
      .get("/rc/cs/web/corp/list/" + vendorNo)
      .then(response => {
        return response;
      });
  },
  deptList: function(corpNo) {
    return defaultAxios(constants.contentType.application_json)
      .get("/rc/cs/web/corp/dept/list/" + corpNo)
      .then(response => {
        return response;
      });
  },
  reOrder: function(req) {
    return defaultAxios(constants.application_json, true)
      .post("/rc/cs/web/corp/external/reorder", req)
      .then(response => {
        return response;
      });
  },
  upDate: function(req) {
    return defaultAxios(constants.application_json, true)
      .post("/rc/cs/web/corp/update", req)
      .then(response => {
        return response;
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/employee.js